let activeVideo = null;

const playVideo = async (videoElement, playBtn) => {
  // Ставимо на паузу попереднє відео, якщо воно є
  if (activeVideo && activeVideo !== videoElement) {
    activeVideo.pause();
    activeVideo.controls = false;

    const prevPlayBtn = activeVideo
      .closest('.media-box')
      ?.querySelector('.video-play');
    if (prevPlayBtn) prevPlayBtn.style.display = '';
  }

  try {
    await videoElement.play();
    videoElement.controls = true;
    playBtn.style.display = 'none';
    activeVideo = videoElement;
  } catch (err) {
    console.log('Playback error:', err);
  }
};

document.querySelectorAll('.media-box').forEach(elem => {
  const video = elem.querySelector('video');
  const videoPlay = elem.querySelector('.video-play');

  const onPlayClick = () => {
    if (!video || !videoPlay) return;
    playVideo(video, videoPlay);
  };

  video.addEventListener('click', onPlayClick);
  videoPlay.addEventListener('click', onPlayClick);

  video.addEventListener('ended', () => {
    video.controls = false;
    videoPlay.style.display = '';
    if (activeVideo === video) activeVideo = null;
  });
});

// Функція ручної зупинки всіх відео
export function pauseVideo() {
  const videos = document.querySelectorAll('.media-box video');
  videos.forEach(video => {
    video.pause();
    video.controls = false;
    const playBtn = video.closest('.media-box')?.querySelector('.video-play');
    if (playBtn) playBtn.style.display = '';
  });
  activeVideo = null;
}

// <div class="media-box">
//    <video poster="/assets/img/content/review_img_1.jpg" preload="metadata">
//     <source src="/assets/img/media/video.mp4" type="video/mp4" />
//     <source src="/assets/img/media/video.webm" type="video/webm" />
//   </video>

//   <button type="button" class="video-play" aria-label="Video play">
//     <span></span>
//   </button>
// </div>
